<!-- <div class="profile-container">
    <div class="">
        <div class="profile-content">

            <div class="personal-details">
                <div class="row">
                    <p>User Tasks</p>
                </div>
                <div class="row">
                    <div class="col-md-7 col-lg-7" style="padding: 0;">
                        <div class="col-md-6 col-lg-6" style="padding-right: 0;">
                            <select class="form-control" [(ngModel)]="userId">
                                <option value="" disable selected hidden>---select user---</option>
                                <option *ngFor="let user of usersList" [value]="user.userId">{{user.userName}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-5 col-lg-5" style="display: flex;padding-left: 0;justify-content: space-between;">
                        <div class="" style="width:39%">
                            <input type="date" [(ngModel)]="date1" class="form-control">
                        </div>
                        <div class="" style="width:39%">
                            <input type="date" [(ngModel)]="date2" class="form-control">
                        </div>
                        <div class="" style="width:20%">
                            <button (click)="getFilteredData(0,10)" class="btn btn-primary">search</button>
                        </div>
                    </div>
                </div>
                <div *ngIf="filteredData == 0">
                    <h4 class="personal-details-title" *ngIf="visible">No User Tasks Available...!</h4>
                </div>
                <table class="table table-striped" *ngIf="filteredData != 0">
                    <thead>
                      <tr>
                        <th scope="col">Task SlNo</th>
                        <th scope="col">Created Date</th>
                        <th scope="col">Name</th>
                        <th scope="col">Description</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let filteredData of filteredData;let i = index">
                        <th scope="col">{{filteredData.taskSlNo}}</th>
                        <th scope="col">{{filteredData.createdDate | date}}</th>
                        <th scope="col">{{filteredData.name}}</th>
                        <th scope="col">{{filteredData.description}}</th>
                        <th scope="col">{{filteredData.latestTaskStatus}}</th>
                      </tr>
                    </tbody>
                </table>
                <div class="pagination-block" *ngIf="filteredData.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
                  <div *ngIf="filteredData.length == 0">
                    <p class="text-center">No records found.</p>
                  </div>
            </div>

        </div>
    </div>
</div> -->


<div class="profile-container">
  <div class="">
      <div class="profile-content">

          <div class="personal-details">
        
            <div class="header-block">
                <div class="header-title">
                    <p>User Tasks</p>
                </div>
                <div class="add-block">
                  <select class="form-control" [(ngModel)]="userId">
                    <option value="" disable selected hidden>---select user---</option>
                    <option *ngFor="let user of usersList" [value]="user.userId">{{user.userName}}</option>
                  </select>
                  <div class="search">
                    <span>From</span>
                      <form autocomplete="off" >
                        <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="date1">
                      </form>
                  </div>
                  <div class="search">
                    <span>To</span>
                    <form autocomplete="off" >
                      <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="date2">
                    </form>
                </div>
                    <button (click)="getFilteredData(0,10)"> search</button>
                </div>
            </div>

            <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 15%;">Task SlNo</th>
                    <th style="width: 20%;">Assigned To</th>
                    <th style="width: 25%;">Description</th>
                    <th style="width: 20%;">Completed %</th>
                    <th style="width: 20%;">Status</th>
                  </tr>
                </thead>
            </table>
            <div *ngIf="!isLoading">
                <div class="data-view" *ngFor="let filtered of filteredData | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }  ;let i = index">

                    <p style="width: 15%;">{{filtered.taskSlNo}}</p>
                    <p style="width: 20%;">{{filtered.assignedToUserName}}</p>
                    <p style="width: 25%;">{{filtered.description}}</p>
                    <p style="width: 20%;">{{filtered.completedPercentage}}%</p>
                    <p style="width: 20%;">{{filtered.latestTaskStatus}}</p>
                </div>
            </div>


            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>

            <div class="loader"  *ngIf="!isLoading && filteredData.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>
                
            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
                </p-paginator>
            </div>


        </div>

      </div>
  </div>
</div>